import React from 'react'
import clsx from 'clsx';
import { ReactComponent as IconCheck } from 'images/check.svg';
import { ReactComponent as IconNoCheck } from 'images/no-check.svg';
import { Link } from 'react-router-dom';
import Skeleton from 'components/shared/Skeleton';
import styles from './Tabs.module.scss';
import { useTranslation } from 'react-i18next';

type TabsOption = {
  id: number,
  title: string,
  isActive?: boolean,
  link?: string,
}

type TabsProps = {
  className?: string,
  items: TabsOption[],
  onSelect?: (id: number) => void,
  value?: number,
  showNoCheck?: boolean,
  white?: boolean,
  inline?: boolean,
  simple?: boolean,
  links?: boolean,
  activeLink?: string,
  queryString?: string,
  gray?: boolean,
  light?: boolean,
}

function Tabs({
  className = '',
  items,
  onSelect,
  value,
  showNoCheck = false,
  white = false,
  inline = false,
  simple,
  links = false,
  gray = false,
  light = false,
  activeLink,
  queryString,
}: TabsProps) {

  const {t} = useTranslation() as any
  if (simple) {
    return (
      <div className={clsx(styles.tabsSimple, className)}>
        {
          items.map(({ id, title, isActive }) => {
            if (isActive === false) {
              return ''
            }
            if (title.length === 0) {
              return (
                <Skeleton
                  className={clsx(styles.tabSimple, styles.tabsListItemSkeleton)}
                />
              )
            }
            return (
              <div
                className={clsx(styles.tabSimple, (id === value) && styles.tabSimpleActive)}
                onClick={() => onSelect && onSelect(id)}
              >
                {title}
              </div>
            )
          })
        }
      </div>
    )
  }
  if (inline && links) {
    return (
      <div className={clsx(styles.tabsInline, white && styles.tabsInlineWhite, className)}>
        {items.map(({ title, link, isActive }) => {
          if (isActive === false) {
            return ''
          }
          return (
            <Link
              to={`${link}${queryString ?? ''}` || '/'}
              className={clsx(styles.tabInline, (link === activeLink) && styles.tabInlineActive)}
              key={title}
            >
              {title}
            </Link>
          )
        })}
      </div>
    )
  }

  if (inline) {
    return (
      <div className={clsx(styles.tabsInline, white && styles.tabsInlineWhite, gray && styles.tabsInlineGray, light && styles.tabsInlineLight, className)}>
        {items.map(({ id, title, isActive }) => {
          if (isActive === false) {
            return ''
          }
          return (
            <div
              className={clsx(styles.tabInline, (id === value) && styles.tabInlineActive)}
              onClick={() => onSelect && onSelect(id)}
              key={id}
            >
              {t(title)}
            </div>
          )
        })}
      </div>
    )
  }

  let NoCheck: React.ReactNode = null
  if (showNoCheck) {
    NoCheck = (white ? (
      <span className={styles.inactiveWhite} />
    ) : (<IconNoCheck />))
  }

  return (
    <div className={clsx(styles.tabs, className, white && styles.tabsWhite)}>
      {
        items.map(({ id, title }) => (
          <div
            className={clsx(styles.tab, (id === value) && styles.tabActive)}
            onClick={() => onSelect && onSelect(id)}
          >
            {(id === value) ? (<IconCheck />) : NoCheck}
            {title}
          </div>
        ))
      }
    </div>
  )
}

export default Tabs
